// import React from "react";
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import { MdShoppingBag } from "react-icons/md";
// import "./userorder.css"
// const UserOrder = () => {
//     return (
//         <>
//             <div className="breadcrumb-wrap bg-f br-2 mt-5">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>My Orders</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="#">Home </Link></li>
//                             <li>My Orders</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>


//             <div>
//                 <div className="ordercon gap-2">
//                     <Usernav />
//                     <div class="col-xl-8 col-lg-12 orders">

//                         <div className="d-flex"><div className="person"><MdShoppingBag /></div> <span style={{ fontSize: "20px" }}>My Orders</span></div>
//                         <div className="ordercontiner">
//                             <ul className="orderdata">
//                                 <li>order#172637157218274</li>
//                                 <li>Pending</li>
//                                 <li>10-Nov-2024</li>
//                                 <li>Rs.1000</li>
//                                 <li>{"->"}</li>
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };
// export default UserOrder;


// import React, { useState, useEffect } from 'react';
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import { MdShoppingBag } from "react-icons/md";

// const UserOrder = () => {
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const phoneNumber = localStorage.getItem("phoneNumber");

//     useEffect(() => {
//         const fetchOrders = async () => {
//             try {
//                 const response = await fetch('/api/orders'); // Replace with your API endpoint
//                 const data = await response.json();
//                 // Filter orders based on phone number
//                 const userOrders = data.filter(order => 
//                     order.customerId === phoneNumber
//                 );
//                 setOrders(userOrders);
//             } catch (error) {
//                 console.error('Error fetching orders:', error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchOrders();
//     }, [phoneNumber]);

//     // Helper function to format date
//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-IN', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric'
//         });
//     };

//     return (
//         <>
//             <div className="breadcrumb-wrap bg-f br-2 mt-5">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>My Orders</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="/">Home </Link></li>
//                             <li>My Orders</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>

//             <div>
//                 <div className="ordercon gap-2">
//                     <Usernav />
//                     <div className="col-xl-8 col-lg-12 orders">
//                         <div className="d-flex">
//                             <div className="person"><MdShoppingBag /></div>
//                             <span style={{ fontSize: "20px" }}>My Orders</span>
//                         </div>

//                         {loading ? (
//                             <div className="text-center p-4">Loading orders...</div>
//                         ) : orders.length === 0 ? (
//                             <div className="text-center p-4">No orders found</div>
//                         ) : (
//                             <div className="ordercontiner">
//                                 {orders.map((order) => (
//                                     <div key={order._id.$oid} className="order-item mb-3">
//                                         <ul className="orderdata">
//                                             <li>Order #{order.orderId}</li>
//                                             <li className={`status-${order.deliveryStatus.toLowerCase()}`}>
//                                                 {order.deliveryStatus.charAt(0).toUpperCase() + 
//                                                  order.deliveryStatus.slice(1)}
//                                             </li>
//                                             <li>{formatDate(order.orderDate.$date)}</li>
//                                             <li>Rs.{order.paymentDetails.totalAmount}</li>
//                                             <li>
//                                                 <Link to={`/order-details/${order._id.$oid}`}>
//                                                     {">"}
//                                                 </Link>
//                                             </li>
//                                         </ul>
//                                         <div className="order-products">
//                                             {order.products.map((product) => (
//                                                 <div key={product._id.$oid} className="product-summary">
//                                                     <img 
//                                                         src={product.image} 
//                                                         alt={product.productName}
//                                                         className="product-thumbnail"
//                                                     />
//                                                     <div className="product-info">
//                                                         <p>{product.productName}</p>
//                                                         <p>Size: {product.size}</p>
//                                                         <p>Quantity: {product.quantity}</p>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default UserOrder;

import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Usernav from "../usernav/usernav";
import { VscArrowRight } from "react-icons/vsc";
import axios from 'axios';
import { MdShoppingBag, MdKeyboardArrowRight } from "react-icons/md";
import "./userorder.css";  // We'll create this next
import { useNavigate } from "react-router-dom";
const UserOrder = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const phoneNumber = localStorage.getItem("phoneNumber");
    const navigate = useNavigate()
    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await fetch('/api/orders');
                const data = await response.json();
                const userOrders = data.filter(order =>
                    order.customerId === phoneNumber
                );
                setOrders(userOrders);
            } catch (error) {
                console.error('Error fetching orders:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [phoneNumber]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };
    const handleViewOrderClick = (orderId) => {
        navigate('/Userorderdetails', { state: { orderId } });
    };
    const isWithinCancelWindow = (orderDate) => {
        const orderTime = new Date(orderDate).getTime();
        const currentTime = new Date().getTime();
        const threeHoursInMs = 3 * 60 * 60 * 1000;
        return currentTime - orderTime <= threeHoursInMs;
    };
    const getTimeRemaining = (orderDate) => {
        const orderTime = new Date(orderDate).getTime();
        const currentTime = new Date().getTime();
        const timeRemaining = (orderTime + (3 * 60 * 60 * 1000)) - currentTime;

        if (timeRemaining <= 0) return "";

        const hoursLeft = Math.floor(timeRemaining / (1000 * 60 * 60));
        const minutesLeft = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));

        return `${hoursLeft}h ${minutesLeft}m left to cancel`;
    };
    const handleCancelOrder = async (orderId) => {
        try {
            const response = await fetch('/api/cancel-order', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ orderId: orderId }),
            });

            const data = await response.json();

            if (response.ok) {
                alert('Cancellation request has been sent to the admin!');
                // Refresh orders after cancellation
                // const updatedOrders = await axios.get(`/api/fetch-order/${localStorage.getItem("phoneNumber")}`);
                // setOrdersdata(updatedOrders.data);
            } else {
                alert('Error sending cancellation request');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while sending the request');
        }
    };
    return (
        <div >
            <div className="breadcrumb-wrap bg-f br-2 ">
                <div className="container">
                    <div className="breadcrumb-title">
                        <h2>My Orders</h2>
                        <ul className="breadcrumb-menu list-style">
                            <li><Link to="/">Home </Link></li>
                            <li>My Orders</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='containerorder'>
                <div className="row">
                    <div className="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
                        <Usernav />
                    </div>
                    <div className="col-xl-7 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
                        <div className='ordercon'>
                            <div className="orders-header">
                                <div className="header-icon">
                                    <MdShoppingBag size={24} />
                                </div>
                                <h3>My Orders</h3>
                            </div>
                            {loading ? (
                                <div className="loading-state">
                                    <div className="spinner"></div>
                                    <p>Loading your orders...</p>
                                </div>
                            ) : orders.length === 0 ? (
                                <div className="empty-state">
                                    <MdShoppingBag size={48} />
                                    <h4>No orders yet</h4>
                                    <p>When you place orders, they will appear here</p>
                                    <Link to="/" className="shop-now-btn">Shop Now</Link>
                                </div>
                            ) : (
                                <div className="orders-list">
                                    {orders.map((order) => (
                                        <div key={order._id.$oid} className="order-card">
                                            <div className="order-header">
                                                <div className="order-meta">
                                                    <span className="order-id">Order #{order.orderId}</span>
                                                    <span className="order-date">
                                                        {formatDate(order.orderDate)}
                                                    </span>
                                                </div>
                                                <div className="order-status-price">
                                                    <span className={`status-badge ${order.deliveryStatus.toLowerCase()}`}>
                                                        {order.deliveryStatus.charAt(0).toUpperCase() +
                                                            order.deliveryStatus.slice(1)}
                                                    </span>
                                                    <span className="order-price">
                                                        ₹{order.paymentDetails.totalAmount.toLocaleString()}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="order-products">
                                                {order.products.map((product) => (
                                                    <div key={product._id.$oid} className="oproduct-card">
                                                        <img
                                                            src={`${product.image}`}
                                                            alt={product.productName}
                                                            className="oproduct-image"
                                                        />
                                                        <div className="oproduct-details">
                                                            <h4>{product.productName}</h4>
                                                            <div className="product-meta">
                                                                <span>Size: {product.size}</span>
                                                                <span>Qty: {product.quantity}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                ))}
                                                <div className='orderbottom'>
                                                <a onClick={() => handleViewOrderClick(order._id)}> View More<VscArrowRight /></a>
                                                {order.deliveryStatus === 'pending' && (
                                                    <div>
                                                        <button
                                                            className="cancelbutton"
                                                            onClick={() => handleCancelOrder(order.orderId)}
                                                            disabled={!isWithinCancelWindow(order.orderDate)}
                                                            style={{
                                                                opacity: isWithinCancelWindow(order.orderDate) ? 1 : 0.5,
                                                                cursor: isWithinCancelWindow(order.orderDate) ? 'pointer' : 'not-allowed'
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <div className="text-sm text-gray-600 mt-1">
                                                            {getTimeRemaining(order.orderDate)}
                                                        </div>
                                                    </div>
                                                )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserOrder;